/**
 * Shared string constants for editor tab discriminants.
 *
 * The synthetic `advanced-parameters` tab is drawer-only — it hosts the
 * Advanced peer section's ParameterList (mode='advanced-only') and does not
 * appear in TAB_CONFIG (so the legacy modal's horizontal tab strip stays
 * unchanged). Consolidating the literal here prevents typos from silently
 * breaking the synthetic-tab dispatch across the several files that reference
 * it (drawer, tab body, section-for-tab map, tests).
 */
export const ADVANCED_PARAMS_TAB = 'advanced-parameters' as const;
